<script>

  import { Navigation, Pagination, A11y } from 'swiper';
  import { Swiper, SwiperSlide } from 'swiper/svelte';
  import {fade, fly, slide} from 'svelte/transition'
  import "carbon-components-svelte/css/g90.css";
  import {Button, Form, TextInput, Select, SelectItem, Checkbox} from 'carbon-components-svelte';
  import {registerUser} from '../auth'
  import {_}  from 'svelte-i18n'
  import Tailwindcss from '../Tailwind.svelte'
  import {Motion, M} from 'svelte-motion'
  import {animateScroll} from 'svelte-scrollto-element'
  import { onMount } from 'svelte';
  import {sessionData} from '../stores'

  import {signInWithGoogle} from '../auth'
	let swiper;
  let testval = false
  let session;
  let anchor
  let anchor_view
  let checkBoxFadeIn = false
  let [c1, c2, c3, c4] = [false, false, false, false]
  let ticks = {
      c1: false,
      c2: false,
      c3: false,
      c4: false

    }
  $: complete = (ticks.c1 && ticks.c2 && ticks.c3 && ticks.c4)
  $: completed = $sessionData.signin_user.displayName && $sessionData.signin_user.location


  export let variants
  export let container
  export let animate

  $: activate = session.signin_flow != "login"


  function onKeyDown(event) {
    if (event.key === 'Enter') {
      register()
    }
  }


  async function register(){
    if(completed && complete){
      registerUser(
          $sessionData.signin_user.displayName,
          $sessionData.signin_user.location,
          "swedish",
          $sessionData.signin_user.dob,


        )

        }



    }

  onMount (async () => {
      setInterval(() => {
        testval = !testval
      }, 1000)
    })


  const list = {
        visible: {
            transition: {
                when: "afterChildren",
                staggerChildren: 0.3,
            },
        },
        hidden: {
            transition: {
                when: "beforeChildren",
            },
        },
    };
    const item = {
        visible: { opacity: 1, x: 0 },
        hidden: { opacity: 0, x: "-50vw" },
    };


  sessionData.subscribe(value => {
    session = value
  })


    animateScroll.setGlobalOptions({
        scrollX: true,
        scrollY: false,
    });




    /* setTimeout(() => { */
      /* checkBoxFadeIn = true */
    /* }, 1000); */

  function onFill(c){

    ticks[c] = !ticks[c]

    }


  const scroller = () => {
      animateScroll.scrollTo({element: anchor})
  }

</script>
<Tailwindcss/>

  <svelte:window on:keydown={onKeyDown} />


  <M.div variants={container} initial="hidden" {animate} class="grid-auto-rows max-h-screen gap-8 select-none">
    <M.h1 {variants} class="min-w-max whitespace-pre-line text-6xl pb-8" >{$_("signUp.tickBoxes")}</M.h1>
  <M.h2 {variants} class="min-w-max text-3xl pb-16">{$_("signUp.confirm")}</M.h2>
  </M.div>



  <div variants={container} initial="hidden" {animate} class="max-h-screen gap-y-16 select-none">



    <div>
    <div   {variants} class="flex flex-row content-center py-3 gap-x-4">
      <input {variants} type="checkbox" class="tickbox" bind:checked={ticks.c1}/>
      <h3 on:click={() => onFill("c1")} {variants} class=" select-none cursor-pointer text-xl align-middle">{$_("signUp.resideIn")} {$sessionData.signin_user.location}</h3>
  </div>

    </div>





    <div>
    <div   {variants} class="flex flex-row content-center py-3 gap-x-4">
      <input {variants} type="checkbox" class="tickbox" bind:checked={ticks.c2}/>
      <h3 on:click={() => onFill("c2")} {variants} class=" select-none cursor-pointer text-xl align-middle">{$_("signUp.notPEP")}</h3>
  </div>


    </div>

    <div>
    <div  {variants} class="flex flex-row content-center py-3 gap-x-4">
      <input {variants} type="checkbox" class="tickbox" bind:checked={ticks.c3}/>
      <h3 on:click={() => onFill("c3")} {variants} class="select-none cursor-pointer text-xl align-middle">{$_("signUp.purpose")}</h3>
  </div>
    </div>

    <div>
    <div  {variants} class="flex flex-row content-center py-3 gap-x-4">
      <input {variants} type="checkbox" class="tickbox" bind:checked={ticks.c4}/>
      <h3 on:click={() => onFill("c4")} {variants} class="select-none cursor-pointer text-xl align-middle">{$_("signUp.soleBenefit")}</h3>
  </div>
    </div>
  </div>

    {#if $sessionData.serverError}
      <M.h1 class="text-red-500 font-brown text-2xl">{$_("common.wentWrong")}</M.h1>
    {/if}


  {#if complete }
    <button in:fly={{x:30}} on:click={register} {variants}>
  <img  class="mt-12 self-end w-32" src="arrow-right.svg" alt="arrow-right.svg"/>
  </button>
  {/if}

<style>
  .tickbox{
    min-width: 24px !important;
    min-height: 24px !important;

    max-width: 24px !important;
    max-height: 24px !important;
    border: 2px solid black;
  }
</style>
